import { ImpactDataset } from "@/hooks/useEcoInventDatasets";
import { ReactNode, useEffect, useState } from "react";

import useIntercom from "@/hooks/useIntercom";
import ImpactReferenceModal from "../ImpactReferenceSelector/ImpactReferenceModal";

export interface DatasetSelectorProps {
  onSelect?: (dataset: ImpactDataset) => void;
  children: ReactNode;
}

export default function DatasetSelector({ onSelect, children }: DatasetSelectorProps) {
  const [selectedDataset, setSelectedDataset] = useState<ImpactDataset>();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { setMarginBottom } = useIntercom();

  const onOpen = () => {
    setIsVisible(true);
    setMarginBottom(85);
  };

  const onClose = () => {
    setIsVisible(false);
    setMarginBottom(0);
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const onSubmit = () => {
    if (selectedDataset) {
      onSelect?.(selectedDataset);
      onClose();
    }
  };

  return (
    <>
      <span onClick={onOpen}>{children}</span>
      {isVisible && (
        <ImpactReferenceModal
          selectedDataset={selectedDataset}
          title={"Add reference"}
          onClose={onClose}
          onSubmit={onSubmit}
          onDatasetChange={setSelectedDataset}
          isLoading={false}
        />
      )}
    </>
  );
}
